import { Text } from '../../Form/Inputs/Text.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Author = (props) => {
    const name = (props.el) ? props.el.name : '';
    const link = (props.el) ? props.el.link : '';
    const id = (props.el) ? props.el.id : '';
    return (
        <>
            <Text name="name" value={name} />
            <Text name="link" value={link} />
            <Hidden name="id" value={id} />
        </>
    )
}